module.exports = __webpack_public_path__ + "media/app-store-detail/android-ad0c498c.svg";